import type {
  SearchJourneyOfferDTO,
  SearchJourneyOffersDTO,
} from '@/types/dto/agent';
import type { OfferMapByLegId } from '@/types/offer';

export const getDefaultOfferMap = (journey: SearchJourneyOffersDTO) => {
  return (
    journey?.trips?.reduce<OfferMapByLegId>(
      (tripsAcc, { legs, offers }) => ({
        ...tripsAcc,
        ...legs?.reduce<OfferMapByLegId>((legsAcc, { id }) => {
          if (!id) {
            return legsAcc;
          }

          const cheapestMatchingOffer =
            offers?.reduce<SearchJourneyOfferDTO | null>(
              (cheapestOffer, currentOffer) => {
                if (currentOffer.coveredLegIds?.includes(id)) {
                  return !cheapestOffer ||
                    (currentOffer.price?.amount ?? 0) <
                      (cheapestOffer?.price?.amount ?? 0)
                    ? currentOffer
                    : cheapestOffer;
                }

                return cheapestOffer;
              },
              null
            );

          return cheapestMatchingOffer
            ? { ...legsAcc, [id]: cheapestMatchingOffer }
            : legsAcc;
        }, {}),
      }),
      {}
    ) ?? {}
  );
};

export const purchaseFlowJourneyOrOfferPaths = [
  '/purchase/outbound/journey',
  '/purchase/outbound/offer',
  '/purchase/inbound/journey',
  '/purchase/inbound/offer',
  '/purchase/non-trip/offer',
];
